import type { EventDetail } from '@/types';
import { mapDtoToEventDetail } from '@/utils/dtoTransformers/eventDetailDTO';

// Update fetchEvent to use the mapping function
// id can be a numeric event ID (regular events) or a 96-character eventcode string (closed events)
export async function fetchEvent(id: number | string): Promise<EventDetail | null> {
  const params = new URLSearchParams({
    id: id.toString()
  });

  try {
    const response = await fetch('/of2/json/event?' + params.toString(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    });
    if (!response.ok) {
      return null;
    }
    const data = await response.json();
    try {
      return data ? mapDtoToEventDetail(data) : null;
    } catch (e) {
      console.error("Failed to map event DTO:", e);
      return null;
    }
  } catch {
    return null;
  }
}